var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteCharity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
    fill: "#DD636E",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_69718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.08 6H12.5862C11.2464 6 10.1602 7.08615 10.1602 8.42605V28.3908C10.1602 29.7306 11.2463 30.8168 12.5862 30.8168H28.08C29.4199 30.8168 30.5061 29.7307 30.5061 28.3908V8.42605C30.5061 7.0862 29.4199 6 28.08 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9172 30.8166H12.5855C11.2462 30.8166 10.1602 29.7305 10.1602 28.3913V8.42594C10.1602 7.08609 11.2462 6 12.5855 6H13.9172C12.5773 6 11.4912 7.08609 11.4912 8.42594V28.3913C11.4912 29.7305 12.5773 30.8166 13.9172 30.8166Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.506 16.2769V28.3912C30.506 29.7309 29.4198 30.8171 28.0801 30.8171H12.586C11.2463 30.8171 10.1602 29.7309 10.1602 28.3912V11.0543C10.3196 11.034 10.4818 11.0239 10.6469 11.0239H18.6514C19.9979 11.0239 21.2469 11.7276 21.9444 12.8791L22.7726 14.2459C23.4706 15.3974 24.7191 16.1011 26.0655 16.1011H29.3534C29.7551 16.1011 30.1421 16.1625 30.506 16.2769Z",
    fill: "#DDDAEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.204 21.413V30.1494C33.204 32.2759 31.4802 33.9998 29.3537 33.9998H10.6473C8.52073 33.9998 6.79688 32.2759 6.79688 30.1494V16.3362C6.79688 14.2097 8.52073 12.4858 10.6473 12.4858H18.6517C19.9983 12.4858 21.247 13.1893 21.9448 14.3409L22.7728 15.7075C23.4706 16.8592 24.7193 17.5626 26.0659 17.5626H29.3536C31.4801 17.5626 33.204 19.2864 33.204 21.413Z",
    fill: "#E63946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6707 33.9997H10.647C8.52084 33.9997 6.79688 32.2757 6.79688 30.1495V16.336C6.79688 14.2093 8.52084 12.4858 10.647 12.4858H12.6707C10.544 12.4858 8.81998 14.2092 8.81998 16.336V30.1495C8.81998 32.2757 10.5439 33.9997 12.6707 33.9997Z",
    fill: "#F25D68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1299 24.4131L23.9494 22.5936C24.2564 22.2866 24.2564 21.7888 23.9494 21.4818L22.9318 20.4641C22.6248 20.1571 22.127 20.1571 21.82 20.4641L20.0005 22.2837L18.181 20.4641C17.874 20.1571 17.3762 20.1571 17.0692 20.4641L16.0516 21.4818C15.7445 21.7888 15.7445 22.2866 16.0516 22.5936L17.8711 24.4131L16.0516 26.2326C15.7445 26.5396 15.7445 27.0374 16.0516 27.3444L17.0692 28.362C17.3762 28.669 17.874 28.669 18.181 28.362L20.0005 26.5425L21.82 28.362C22.127 28.669 22.6248 28.669 22.9318 28.362L23.9494 27.3444C24.2564 27.0374 24.2564 26.5396 23.9494 26.2326L22.1299 24.4131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_69718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCharity);
export default __webpack_public_path__ + "static/media/deleteCharity.152a1be19e17e15d6776076720f27247.svg";
export { ForwardRef as ReactComponent };